'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function validateTransitionProp(props, propName) {
    if (typeof props[propName] !== 'number' && props[propName] !== false) {
        return new Error(propName + ' must be a number (in milliseconds) or false');
    } else if (typeof props[propName] === 'number') {
        if (props[propName] <= 0) {
            return new Error(propName + ' must be a number (in milliseconds) greater than 0');
        }
    }

    return undefined;
}

exports.default = validateTransitionProp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/CustomCSSTransitionGroup/validateTransitionProp.js
// module id = 664
// module chunks = 0